import { createSlice } from "@reduxjs/toolkit";
import authApi from "interceptor/authInterceptor";
import { get } from "lodash";
import { dispatch } from "store";
import T from "utils/constants/T";
import toast from "utils/ToastNotistack";

export type companyTabProps = {
  companyId: string;
  companyName: string;
  contactPerson: string;
  companyEmail: string;
  companyPhone: string;
  companyMemberSince: string;
  city: string;
  abn: string;
  addressCompany: string;
  postCodeCompany: string;
  systemName: string;
  totalNumberOfEmployees: string | number;
  allowablePercentageDrawdown: number | string;
  minimumWithdrawl: string | number;
  transactionFee: string | number;
  floatAlertThresholdAmount: string | number;
  totalAmountPerCompany: string | number;
  floatAlertRecipients: string;
  transactionFeeType: string;
  systemPayrollId: string;
  systemPayrollCode: string;
  cashDCapitalId: string;
  paymentSystemId: string;
  primaryColor: string;
  secondaryColor: string;
  logoUrl: string;
  cashDFeeId: string;
  activePayroll: boolean;
  systemCode: string;
  includeSubmitted: boolean;
  bankingEnvironment: boolean;
  bankingValidateBankAccount: boolean;
  loader: boolean;
  error: null;
  custom: boolean;
  emailLogo: string;
  apiUserName: string;
  apiPassword: string;
  apiKey: string;
  baseUrl: string;
  userName: string;
  userPassword: string;
  countryName : string;
  currencyCode: string;
  currencySymbol: string;
  editCountryDetails : boolean;
  countryList : [];
  countryID: string;
  niumTermsAcceptedLenderIds: string[];
  multipleCompanies: [];
  webhookEnabled: boolean;
  is_business_unit_feature_enable: boolean,
  employee_cost_source:string,
  reckonAuthDetails?: any;
  xeroAuthDetails?: any;
  auth_myob?: {
    baseUrl: string;
    userName: string;
    userPassword: string;
  } | null;
  auth_timesite?: {
    companyName: string;
    siteName: string;
    workspaceName: string;
    apiKey: string;
  } | null;
};

// initial state
const initialState: companyTabProps = {
  companyId: "",
  companyName: "",
  contactPerson: "",
  companyEmail: "",
  companyPhone: "",
  companyMemberSince: "",
  city: "",
  abn: "",
  addressCompany:"",
  postCodeCompany: "",
  systemName: "",
  allowablePercentageDrawdown: "",
  minimumWithdrawl: "",
  transactionFee: "",
  transactionFeeType: "$",
  floatAlertThresholdAmount: "",
  floatAlertRecipients: "",
  totalNumberOfEmployees: "",
  totalAmountPerCompany: "",
  systemPayrollId: "",
  systemPayrollCode: "",
  cashDCapitalId: "",
  cashDFeeId: "",
  activePayroll: false,
  systemCode: "",
  paymentSystemId: "",
  primaryColor: "",
  secondaryColor: "",
  logoUrl: "",
  bankingEnvironment: false,
  bankingValidateBankAccount: false,
  includeSubmitted: false,
  loader: false,
  error: null,
  custom: false,
  emailLogo: "",
  apiKey:"",
  apiPassword:"",
  apiUserName: "",
  baseUrl: "",
  userName: "",
  userPassword: "", 
  countryName : "",
  currencyCode: "",
  currencySymbol: "",
  editCountryDetails : false,
  countryList : [],
  countryID: "",
  niumTermsAcceptedLenderIds: [],
  multipleCompanies: [],
  webhookEnabled: false,
  is_business_unit_feature_enable: false,
  employee_cost_source: "",
  reckonAuthDetails: null,
  xeroAuthDetails: null,
  auth_myob: null,
  auth_timesite: null,
};

// ==============================|| SLICE - Company Details Tab ||============================== //

const companyTabData = createSlice({
  name: "companyTabData",
  initialState,
  reducers: {
    getCompanyTabData(state, action) {
      let {
        companyId,
        companyName,
        companyEmail,
        companyPhone,
        companyMemberSince,
        city,
        abn,
        addressCompany,
        postCodeCompany,
        systemName,
        contactPerson,
        allowablePercentageDrawdown,
        minimumWithdrawl,
        transactionFee,
        transactionFeeType,
        floatAlertThresholdAmount,
        totalNumberOfEmployees,
        totalAmountPerCompany,
        floatAlertRecipients,
        systemPayrollId,
        systemPayrollCode,
        cashDCapitalId,
        cashDFeeId,
        activePayroll,
        systemCode,
        includeSubmitted,
        apiKey,
        apiUserName,
        apiPassword,
        baseUrl,
        userName,
        userPassword,
        countryName,
        currencyCode,
        currencySymbol,
        editCountryDetails,
        countryID,
        paymentSystemId,
        niumTermsAcceptedLenderIds,
        webhookEnabled,
        is_business_unit_feature_enable,
        employee_cost_source,
        reckonAuthDetails,
        xeroAuthDetails,
        auth_myob,
        auth_timesite
      } = action.payload;
      state.companyId = companyId || initialState.companyId;
      state.companyName = companyName || initialState.companyName;
      state.contactPerson = contactPerson || initialState.contactPerson;
      state.companyEmail = companyEmail || initialState.companyEmail;
      state.companyPhone = companyPhone || initialState.companyPhone;
      state.companyMemberSince =
        companyMemberSince || initialState.companyMemberSince;
      state.city = city || initialState.city;
      state.abn = abn || initialState.abn;
      state.systemName = systemName || initialState.systemName;
      state.allowablePercentageDrawdown =
        allowablePercentageDrawdown ?? initialState.allowablePercentageDrawdown;
      state.minimumWithdrawl =
        minimumWithdrawl ?? initialState.minimumWithdrawl;
      state.transactionFee = transactionFee ?? initialState.transactionFee;
      state.transactionFeeType =
        transactionFeeType ?? initialState.transactionFeeType;
      state.floatAlertThresholdAmount =
        floatAlertThresholdAmount || initialState.floatAlertThresholdAmount;
      state.totalNumberOfEmployees =
        totalNumberOfEmployees || initialState.totalNumberOfEmployees;
      state.totalAmountPerCompany =
        totalAmountPerCompany ?? initialState.totalAmountPerCompany;
      state.floatAlertRecipients =
        floatAlertRecipients || initialState.floatAlertRecipients;
      state.systemPayrollId = systemPayrollId || initialState.systemPayrollId;
      state.systemPayrollCode =
        systemPayrollCode || initialState.systemPayrollCode;
      state.cashDCapitalId = cashDCapitalId || initialState.cashDCapitalId;
      state.cashDFeeId = cashDFeeId || initialState.cashDFeeId;
      state.activePayroll = activePayroll || initialState.activePayroll;
      state.systemCode = systemCode || initialState.systemCode;
      state.niumTermsAcceptedLenderIds = niumTermsAcceptedLenderIds || initialState.niumTermsAcceptedLenderIds;
      state.webhookEnabled = webhookEnabled || initialState.webhookEnabled
      state.is_business_unit_feature_enable = is_business_unit_feature_enable || initialState.is_business_unit_feature_enable;
      state.employee_cost_source = employee_cost_source || initialState.employee_cost_source;
      state.reckonAuthDetails = reckonAuthDetails || initialState.reckonAuthDetails;
      state.xeroAuthDetails = xeroAuthDetails || initialState.xeroAuthDetails;
      state.auth_myob = auth_myob || initialState.auth_myob;
      state.auth_timesite = auth_timesite || initialState.auth_timesite;
      state.includeSubmitted =
        includeSubmitted || initialState.includeSubmitted;
        state.apiKey = apiKey || initialState.apiKey;
        state.apiUserName = apiUserName || initialState.apiUserName;
        state.apiPassword = apiPassword || initialState.apiPassword;
        state.baseUrl = baseUrl || initialState.baseUrl;
        state.userName = userName || initialState.userName;
        state.userPassword = userPassword || initialState.userPassword;
        state.countryName = countryName || initialState.countryName;
        state.currencyCode = currencyCode || initialState.currencyCode;
        state.currencySymbol = currencySymbol || initialState.currencySymbol;
        state.editCountryDetails = editCountryDetails || initialState.editCountryDetails;
        state.countryID = countryID || initialState.countryID;
        state.paymentSystemId = paymentSystemId || initialState.paymentSystemId;
        state.addressCompany = addressCompany || initialState.addressCompany;
        state.postCodeCompany = postCodeCompany || initialState.postCodeCompany;
    },
    getBankingTabData(state, action) {
      let { bankingEnvironment, bankingValidateBankAccount, paymentSystemId } =
        action.payload;
      state.bankingEnvironment =
        bankingEnvironment || initialState.bankingEnvironment;
      state.bankingValidateBankAccount =
        bankingValidateBankAccount || initialState.bankingValidateBankAccount;
      state.paymentSystemId = paymentSystemId || initialState.paymentSystemId;
    },
    getWhiteLabelTabData(state, action) {
      let { primaryColor, logoUrl, secondaryColor, custom } = action.payload;
      state.primaryColor = primaryColor || initialState.primaryColor;
      state.secondaryColor = secondaryColor || initialState.secondaryColor;
      state.logoUrl = logoUrl || initialState.logoUrl;
      state.custom = custom || initialState.custom;
    },
    getEmailtemplate(state, action) {
      let { emailLogo } = action.payload;
      state.emailLogo = emailLogo || initialState.emailLogo;
    },
    getMultipleCompany(state, action) {
      let { multipleCompanies } = action.payload;
      state.multipleCompanies = multipleCompanies || initialState.multipleCompanies;
    },
    isLoading(state, action) {
      state.loader = action.payload;
    },
    hasError(state, action) {
      state.error = action.payload;
    },
    clearCompany(state) {
      return initialState;
    },
    updatePaymentSystemId: (state, action) => {
      state.paymentSystemId = action.payload;
    },
    updateCompanyDetails: (state: any, actions) => {
      const { key, value } = actions.payload;
      state[key] = value;
    },
    clearCompanyTabDetails: (state) => initialState,
    getCountryDetailsSuccess(state, action) {
      let { countryList } = action.payload;

      state.countryList = countryList || initialState.countryList;
    }
  },
});

export default companyTabData.reducer;

export const {
  getCompanyTabData,
  getBankingTabData,
  clearCompany,
  updatePaymentSystemId,
  getWhiteLabelTabData,
  getEmailtemplate,
  updateCompanyDetails,
  clearCompanyTabDetails,
  getCountryDetailsSuccess,
  getMultipleCompany
} = companyTabData.actions;

// ==============================|| Get Company Details ||============================== //

export const getMultipleCompanies = async () => {
  try {
    const response = await authApi.get(`/v2/api/users/multipleCompanies`);
    if (response.data) {
      const multipleCompany = response.data.data;
      dispatch(
        getMultipleCompany({
          multipleCompanies: multipleCompany,
        })
      );
    }
  } catch (error) {
    console.log(error);
  }
};

const COUNTRY_MAP: Record<string, string> = {
  AUD: "Australia",
  NZD: "New Zealand",
  GBP: "United Kingdom",
  USD: "United States",
  AED: "UAE",
  EUR: "Eurozone",
  CAD: "Canada",
  SGD: "Singapore",
};

const SYMBOL_MAP: Record<string, string> = {
  AUD: "$",
  NZD: "$",
  USD: "$",
  GBP: "£",
  AED: "د.إ",
  EUR: "€",
  CAD: "$",
  SGD: "$",
};

export function fetchCompanyDetails(companyId: string) {
  return async () => {
    try {
      const response = await authApi.get(
        `/v2/api/companies/getCompany/${companyId}`
      );
      if (response.data && response.data.data) {
        const finalData = response.data.data;
        const rawCurrency = (get(finalData, "currency", "AUD") || "AUD").toUpperCase();
        const countryCurrencyCode = get(finalData, "countryCurrencyCode", "") || rawCurrency;
        const currencySymbol = get(finalData, "currencySymbol", "") || SYMBOL_MAP[rawCurrency] || "$";
        const countryName = get(finalData, "countryName", "") || COUNTRY_MAP[rawCurrency] || "Australia";

        const transactionFeeTypeValue = get(finalData, "transaction_fee_type", "");
        const transactionFeeType = transactionFeeTypeValue === "PERCENT" ? "%" : currencySymbol;

        dispatch(
          getCompanyTabData({
            companyId: get(finalData, "_id", ""),
            companyName: get(finalData, "company_name", ""),
            contactPerson: get(finalData, "contact_person", ""),
            companyPhone: get(finalData, "phone_company", ""),
            companyEmail: get(finalData, "email_company", ""),
            companyMemberSince: get(finalData, "created_date", ""),
            city: get(finalData, "city", ""),
            abn: get(finalData, "abn", ""),
            systemName: get(finalData, "system_id.system_name", ""),
            allowablePercentageDrawdown: get(
              finalData,
              "limit_allowable_percent_drawdown",
              ""
            ),
            minimumWithdrawl: get(finalData, "min_withdrawal", ""),
            transactionFee: get(finalData, "transaction_fee_value", ""),
            transactionFeeType,
            totalNumberOfEmployees: get(
              finalData,
              "limit_number_of_employee",
              ""
            ),
            totalAmountPerCompany: get(finalData, "limit_money", ""),
            floatAlertThresholdAmount: get(finalData, "threshold_amount", ""),
            floatAlertRecipients: get(
              finalData,
              "recipients_float_alert",
              []
            ).toString(),
            systemPayrollId: get(finalData, "system_id._id", ""),
            systemPayrollCode: get(finalData, "system_id.code", ""),
            cashDCapitalId: get(finalData, "keypay_deduction_category_id", ""),
            cashDFeeId: get(finalData, "keypay_deduction_category_fee_id", ""),
            activePayroll: get(finalData, "is_payroll_setup", false),
            systemCode: get(finalData, "system_id.code", ""),
            includeSubmitted: get(finalData, "is_system_approve_process", false),
            apiPassword : get(finalData,"system_api_password", ""),
            apiUserName: get(finalData, "system_api_username",""),
            apiKey : get(finalData, "x_api_key",""),
            baseUrl :get(finalData, "baseUrl" ,""),
            userName : get(finalData, "userName",""),
            userPassword : get(finalData, "userPassword",""),
            countryName,
            currencyCode: countryCurrencyCode,
            currencySymbol,
            editCountryDetails: get(finalData, "enable_country_feature", false),
            countryID: get(finalData, "country_id", ""),
            paymentSystemId: get(finalData, "payment_system_id", ""),
            postCodeCompany: get(finalData, "post_code", "") || get(finalData, "postcode", ""),
            addressCompany: get(finalData, "address", ""),
            niumTermsAcceptedLenderIds: get(finalData,"nium_terms_accepted_lender_ids"),
            webhookEnabled: get(finalData,"webhook_enabled", false),
            is_business_unit_feature_enable : get(finalData, "is_business_unit_feature_enable",false),
            employee_cost_source : get(finalData, "employee_cost_source","TIMESITE_PRO"),
            reckonAuthDetails: get(finalData, "reckonAuthDetails", null),
            xeroAuthDetails: get(finalData, "xeroAuthDetails", null),
            auth_myob: get(finalData, "auth_myob", null),
            auth_timesite: get(finalData, "auth_timesite", null),
          })
        );
        dispatch(
          getBankingTabData({
            bankingEnvironment: get(finalData, "is_monoova_live_mode", false),
            bankingValidateBankAccount: get(
              finalData,
              "is_validate_bank_account",
              false
            ),
            paymentSystemId: get(finalData, "payment_system_id", ""),
          })
        );
        dispatch(
          getWhiteLabelTabData({
            primaryColor: get(finalData, "brand.primaryColor", "Default"),
            secondaryColor: get(finalData, "brand.secondaryColor", "Default"),
            logoUrl: get(finalData, "brand.logoUrl", "Default"),
            custom: get(finalData, "brand.custom", false),
          })
        );
        dispatch(
          getEmailtemplate({
            emailLogo: get(finalData, "emailTemplateLogo.location", ""),
          })
        );
      }
    } catch (error: any) {
      console.error("Error fetching company details:", error);
      const errorMsg = error?.response?.data?.message || "Company country code not assigned by Super Admin.";
      toast(errorMsg, { variant: "error" });
    }
  };
}

// ==============================|| Save Company Details ||============================== //
export function saveCompanyTabData(
  companyId: string,
  payload: any,
  navigator: any
) {
  return async (dispatch: any, getState: () => any) => {
    try {
      const state = getState();
      const countryName = state?.companyTabData?.countryName;
      const response = await authApi.put(
        `/v2/api/companies/editCompany/${companyId}`,
        payload,
        { skipErrorHandler: true }
      );
      const data = response as any || {};
      if (data?.data?.success) {
        toast(T.COMPANY_DETAILS_HAS_BEEN_SAVED_SUCCESSFULY, {
          variant: "success",
        });
        navigator("/companyDetails/company/view");
        return;
      }
      if (!data?.response?.data?.success && data?.response?.data?.message) {
        const isNZ = countryName === "New Zealand";
        const messages = data.response.data.message
          .split(",")
          .map((msg: string) => {
            const trimmedMsg = msg.trim();
            return isNZ && trimmedMsg === "ABN is required"
              ? `${T.IRD} is required`
              : trimmedMsg;
          });
        toast(messages.join(", "), { variant: "error" });
      }
    } catch (error: any) {
      console.error("Save company error:", error);
      toast("An unexpected error occurred.", {
        variant: "error",
      });
    }
  };
}

export function getCountryDetails() {

  return async () => {
    const response = await authApi.get(
      `/v2/api/companies/getCountries`
    );
    if (response.data) {
      dispatch(
        getCountryDetailsSuccess({
          countryList: response.data.data,
        })
      );
     
    }
  };
}

// ==============================|| ADD NEW COUNTRY ||============================== //
export function addNewCountry(
  payload: any,
  navigator: any
) {
  return async () => {
    const response = await authApi.post(
      `/v2/api/companies/addNewCountry`,
      payload
    );
    if (response.data) {
      dispatch(getCountryDetails());
      toast(T.NEW_COUNTRY_HAS_BEEN_ADDED, {
        variant: "success",
      });
      navigator("/companyDetails/company/edit");
    }
  };
}
